import Strips from './Strips';
import StripsContainer from './Strips.container';

export default StripsContainer(Strips);
